<template>
  <div class="audioPlayer">
    <div class="timeDisplay">
      {{ this.currentTime | formatTimeString }}
      <span class="duration">{{ this.trackDuration | formatTimeString }}</span>
    </div>
    <div
      class="progressBar"
    >
      <div class="progress" :style="fillProgress"></div>
      <div class="drager" :style="posDrager" ref="drager">
        <div class="dot"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { setTimeout } from 'timers';

export default {
  name: 'audioPlayer',
  components: {
  },
  props: {
  },
  data() {
    return {
      audio: null,
      trackDuration: 0,
      currentTime: 0,
      currentProgress: 0,
      updateTimeOut: null,
      isPlaying: false,
      rafPending: false,
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters(['currentExhibit', 'currentPlayerAudio', 'playerAudioActive']),
    fillProgress() {
      return `width: ${this.currentProgress}%`;
    },
    posDrager() {
      return `left: ${this.currentProgress}%`;
    },
    hasTouch() {
      return this.$helper.hasTouch();
    },
  },
  methods: {
    ...mapActions(['setPlayerAudio', 'setPlayerAudioActive']),
    initAudio() {
      if (process.env.VUE_APP_DEBUG === 'on') console.log('Init Audio');

      // use progress passed from exhibit
      // this.currentProgress = this.currentPlayerAudio.progress;

      /* let t = 0; NOT WORKING; USES DURATION OF OLD TRACK IF NOT SAVED IN JSON
      if (this.currentPlayerAudio.progress > 0 && this.currentPlayerAudio.progress < 100) {
        t = Math.round(this.progressToTime(this.currentPlayerAudio.progress));
        this.currentProgress = this.currentPlayerAudio.progress;
        this.currentTime = t;
        console.log(t);
      }
      const file = `${this.currentPlayerAudio.path}#t=${t}`; */
      const file = `${this.currentPlayerAudio.path}`;
      this.isLoading = true;

      // this.trackDuration = Math.round(this.currentPlayerAudio.duration);

      if (this.audio !== null) {
        this.audio.pause();
      }
      this.audio = new Audio(file);
      // this.audio.preload = 'auto';
      this.audio.onloadedmetadata = () => { this.metaDataLoaded(); };
      this.audio.onloadeddata = () => { this.dataLoaded(); };
      this.audio.onended = () => { this.handleEnded(); };
      this.registerLoadingEvents();
    },
    metaDataLoaded() {
      this.trackDuration = Math.round(this.audio.duration);
      this.playAudio();
    },
    dataLoaded() {
      if (this.currentPlayerAudio.progress > 0 && this.currentPlayerAudio.progress < 100) {
        this.audio.currentTime = this.progressToTime(this.currentPlayerAudio.progress);
      }
      this.updateTimeProgress();
    },
    playAudio() {
      if (!this.playerAudioActive) return;
      if (this.isPlaying) {
        this.stopAudio();
      } else {
        this.updatePlayerEverySecond();
        this.audio.play();
        this.isPlaying = true;
        if (process.env.VUE_APP_DEBUG === 'on') console.log('Play Audio');
      }
    },
    stopAudio() {
      this.audio.pause();
      this.isPlaying = false;
      clearTimeout(this.updateTimeOut);
      if (process.env.VUE_APP_DEBUG === 'on') console.log('Stop Audio');
    },
    setAudioProgress(event) {
      let posX = 0;
      if (this.hasTouch) {
        posX = event.touches[0].clientX;
      } else {
        posX = event.clientX;
      }
      const widthProgress = ((posX - this.$el.getBoundingClientRect().x)
        / this.$el.offsetWidth) * 100;
      this.audio.currentTime = this.progressToTime(widthProgress);
      this.updateTimeProgress();
    },
    handleEnded() {
      this.stopAudio();
      this.setProgressExternal(100);
      this.setPlayerAudioActive(false);
      this.currentProgress = 0;
      this.currentTime = 0;
      this.clearLoadingEvents();
      if (process.env.VUE_APP_DEBUG === 'on') console.log(' from Audio Player Audio Finished');
    },
    updatePlayerEverySecond() {
      this.updateTimeOut = setTimeout(() => {
        if (this.isPlaying) {
          this.updateTimeProgress();
          this.updatePlayerEverySecond();
        }
      }, 1000);
    },
    updateTimeProgress() {
      // console.log(this.audio.duration);
      this.currentTime = Math.round(this.audio.currentTime);
      this.currentProgress = Math.round((this.audio.currentTime / this.trackDuration) * 100);
      this.setProgressExternal(this.currentProgress);
      // this.trackDuration = Math.round(this.audio.duration);
    },
    progressToTime(percentage) {
      return this.$helper.clamp((percentage / 100) * this.trackDuration - 1,
        0, this.trackDuration - 1);
    },
    setProgressExternal(progress) {
      if (this.currentExhibit !== null
        && this.currentExhibit.audio !== null
        && this.currentExhibit.progress < progress) {
        this.currentExhibit.progress = progress; // THIS SHOULD BE DONE IN MEDIAPLAYER
      }
      if (this.currentPlayerAudio.progress < progress) {
        this.currentPlayerAudio.progress = progress;
      }
    },
    registerLoadingEvents() {
      // this.audio.onstalled = () => { this.isLoading = true; };
      this.audio.onwaiting = () => { this.isLoading = true; };
      this.audio.onplaying = () => { this.isLoading = false; };
    },
    clearLoadingEvents() {
      // this.audio.onstalled = null;
      this.audio.onwaiting = null;
      this.audio.onplaying = null;
    },
    touchstart() {
      if (this.hasTouch) {
        this.$refs.drager.ontouchmove = (event) => { this.touchmove(event); };
        document.ontouchend = () => { this.touchend(); };
      } else {
        this.$refs.drager.onmousemove = (event) => { this.touchmove(event); };
        document.onmouseup = () => { this.touchend(); };
      }
    },
    touchmove(e) {
      if (this.rafPending) {
        return;
      }
      this.rafPending = true;
      window.requestAnimationFrame(() => this.touchOnAnimFrame(e));
    },
    touchend() {
      if (this.hasTouch) {
        this.$refs.drager.ontouchmove = null;
        document.ontouchend = null;
      } else {
        this.$refs.drager.onmousemove = null;
        document.onmouseup = null;
      }
    },
    touchOnAnimFrame(e) {
      if (!this.rafPending) {
        return;
      }
      this.setAudioProgress(e);
      this.rafPending = false;
    },
  },
  watch: {
    playerAudioActive(newValue) {
      if (this.isPlaying && !newValue) {
        this.stopAudio();
        if (process.env.VUE_APP_DEBUG === 'on') console.log('Audio Canceled');
      }
    },
  },
  filters: {
    formatTimeString(s) {
      /* eslint-disable-next-line */
      return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    },
  },
  mounted() {
    if (this.hasTouch) {
      this.$refs.drager.ontouchstart = () => { this.touchstart(); };
    } else {
      this.$refs.drager.onmousedown = () => { this.touchstart(); };
    }
  },
  beforeDestroy() {
    this.$refs.drager.ontouchstart = null;
    this.$refs.drager.onmousedown = null;
    if (this.audio !== null) {
      this.audio.onloadedmetadata = null;
      this.audio.onended = null;
      this.audio.onloadeddata = null;
      this.clearLoadingEvents();
    }
    clearTimeout(this.updateTimeOut);
  },
};
</script>

<style scoped lang="scss">
.audioPlayer {
  height: 6vh;
  height: calc(var(--vh, 1vh) * 6);
  min-height: 40px;
  box-sizing: border-box;
  /* background-color: #eee;
  background-color: var(--main-background-color); */

  &.disabled {
    display: none;
  }

  .progressBar {
    position: relative;
    height: 2px;
    width: 100%;
    background-color: var(--main-elements-disabled-color);

    .progress {
      position: absolute;
      top: -2px;
      height: 5px;
      background-color: var(--main-elements-color);
    }
    .drager{
      position: absolute;
      top: -25px;
      margin-left: -24px;
      padding: 20px;

      .dot {
        width: 10px;
        height: 10px;
        border-radius: 20px;
        background-color: var(--main-elements-color);
      }
    }
  }
  .timeDisplay {
    font-size: .9em;
    text-align: left;
    padding: 6px 0 4px 0;
    padding: 1vh 0;
    padding: var(--vh, 1vh) 0 ;
    color: var(--main-elements-color);

    .duration {
      float: right;
      text-align: right;
    }
  }
}
@media only screen and (orientation : landscape) {
  .audioPlayer {
    height: 40px;
    margin: 1em 0;
  }
}
</style>
